import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import { ApiKey } from 'types/gateway'
import RouteContainer from 'src/components/App/RouteContainer'

const ApiKeyList = React.lazy(() => loadComponent('api_gateway', 'ApiKeyList'))

const StyledHeading = styled(Typography)`
    margin-bottom: ${({ theme }) => theme.spacing(1)};
`

export function ApiKeyIndexRoute() {
    const navigate = useNavigate()

    const canCreate = usePermission('apigateway.apikey.create', {})
    const canDelete = usePermission('apigateway.apikey.delete', {})

    const onSelect = useCallback(
        (apiKey: ApiKey) => {
            navigate(apiKey._id)
        },
        [navigate],
    )

    const onCreate = useCallback(() => {
        navigate('/settings/apikeys/new')
    }, [navigate])

    return (
        <RouteContainer>
            <StyledHeading variant="h4">API Schlüssel</StyledHeading>
            <ApiKeyList onSelect={onSelect} onCreate={onCreate} canCreate={canCreate} canDelete={canDelete} />
        </RouteContainer>
    )
}
